function initCustomSelect() {
    const optionMenus = document.querySelectorAll(".js-select-menu");

    optionMenus.forEach((optionMenu) => {
        const selectBtn = optionMenu.querySelector(".js-select-btn");
        const options = optionMenu.querySelectorAll(".js-option");
        const sBtn_text = optionMenu.querySelector(".js-sBtn-text");
        const optionsList = optionMenu.querySelector(".select-menu__options");

        selectBtn.addEventListener("click", () => {
            optionMenu.classList.toggle("active");

            if (optionMenu.classList.contains("mob-style")) {
                if (optionMenu.classList.contains("active")) {
                    const maxVisibleOptions = 5; // Максимальна кількість видимих опцій
                    let totalHeight = 0;

                    options.forEach((option, index) => {
                        if (index < maxVisibleOptions) {
                            totalHeight += option.getBoundingClientRect().height;
                        }
                    });
                    optionsList.style.maxHeight = `${totalHeight}px`;
                    document.addEventListener("click", handleOutsideClick);
                } else {
                    optionsList.style.maxHeight = "";
                    document.removeEventListener("click", handleOutsideClick);
                }
            }
        });

        options.forEach((option) => {
            option.addEventListener("click", () => {
                const selectedOption = option.querySelector(".js-option-txt").innerText;
                sBtn_text.innerText = selectedOption;
                optionMenu.classList.remove("active");
                if (optionMenu.classList.contains("mob-style")) {
                    optionsList.style.maxHeight = "";
                }
            });
        });

        function handleOutsideClick(event) {
            if (!optionMenu.contains(event.target)) {
                optionMenu.classList.remove("active");
                optionsList.style.maxHeight = "";
                document.removeEventListener("click", handleOutsideClick);
            }
        }
    });
}

document.addEventListener("DOMContentLoaded", () => {
    initCustomSelect();
})